import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let Loading = class Loading extends Vue {};
Loading = __decorate([Component({
  name: "Loading"
})], Loading);
export default Loading;